import templateUrl from "emun.invoice/credit-request/credit-request-list-cards.htm";

export default () => ({ templateUrl });
